import { EntryTypeCreateForm } from 'chaika-frontend-types/frontend-cms';
import type { SectionParams } from 'chaika-types';

import { EntryTypeDraft, EntryTypeDraftSection } from '../types';

export function makeEntryTypeSaveParams(draft: EntryTypeDraft): EntryTypeCreateForm {
    return {
        title: draft.title,
        type: draft.type,
        legalEntityIds: draft.legalEntityIds,
        titleTranslations: draft.titleTranslations ?? [],
        isNested: draft.isNested,
        isDefault: draft.isDefault,
        sections: draft.sections.map(makeSectionSaveParams).filter(section => section.blocks.length > 0),
    };
}

function makeSectionSaveParams(section: EntryTypeDraftSection): SectionParams {
    return {
        title: section.title,
        collapsible: section.collapsible,
        settings: section.settings,
        titleTranslations: section.titleTranslations ?? [],
        blocks: section.blocks.map(({ id, version }) => ({ id, version })),
    };
}
